(function() { function _dc_leaflet(dc, d3, L) {
'use strict';
